import { useCallback } from 'react';
import { API_BASE_URL, authHeaders } from './api';

// Saves one section endpoint and returns the fetch promise so a caller can
// await it before navigating away. Every write in this app is triggered by
// an explicit action (a Save button, a toggle, a finished upload) rather
// than continuous typing, so there's nothing worth debouncing - saving
// immediately is what lets a page that navigates right after a save trust
// the write has actually landed before the next page re-fetches.
export function useSaveSection(endpoint) {
  return useCallback(
    (buildPayload) =>
      fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify(buildPayload()),
      })
        .then((response) => {
          if (response.ok) window.dispatchEvent(new Event('profile-section-updated'));
          return response;
        })
        .catch(() => undefined),
    [endpoint]
  );
}
